// Shared constants + date helpers for the Analytics dashboard.

export const SOURCE_COLORS = {
  direct: "#0ea5e9",
  social: "#e11d48",
  referral: "#f59e0b",
  search: "#10b981",
};

export const DRAW_BAR_COLORS = {
  millennium: "#f59e0b",
  luxury_car: "#0ea5e9",
  motorcycle: "#e11d48",
};

export function formatDuration(seconds) {
  const s = Math.max(0, Math.round(seconds || 0));
  const m = Math.floor(s / 60);
  const ss = s % 60;
  return m > 0 ? `${m}m ${ss}s` : `${ss}s`;
}

export function isoDate(d) {
  if (!d) return "";
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

function startOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1);
}
function endOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth() + 1, 0);
}

export function presetRanges() {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const last7Start = new Date(today);
  last7Start.setDate(today.getDate() - 6);
  const last30Start = new Date(today);
  last30Start.setDate(today.getDate() - 29);
  const thisMonthStart = startOfMonth(today);
  const prevMonthAnchor = new Date(today.getFullYear(), today.getMonth() - 1, 1);
  const thisYearStart = new Date(today.getFullYear(), 0, 1);
  return [
    { id: "today", label: "Today", start: today, end: today },
    { id: "last_7", label: "Last 7 Days", start: last7Start, end: today },
    { id: "last_30", label: "Last 30 Days", start: last30Start, end: today },
    { id: "this_month", label: "This Month", start: thisMonthStart, end: today },
    { id: "last_month", label: "Last Month", start: startOfMonth(prevMonthAnchor), end: endOfMonth(prevMonthAnchor) },
    { id: "this_year", label: "This Year", start: thisYearStart, end: today },
  ];
}
